module.exports = __webpack_public_path__ + "static/media/QIMRB_dark.d0f78ace.png";